import React from 'react';
import { useRef } from 'react';
import { Link } from "react-router-dom";
import imageOnError from '../helpers/imgOnError.js';
import { useAuth } from '../helpers/authContext.js'

export default function AuthLock() {
	const { currentUser } = useAuth();
	if (currentUser === true) return null;

	return (
		<>
            <span className="wts-pass-text" 
				style={{ cursor: 'pointer', pointerEvents: 'auto', color: '#8491a5' }}>
				{' '}            
				<i            
					className="mdi mdi-lock" 
					aria-disabled="true"
					style={{ fontSize: '14px' }}
					title="Login to access"
				/>
            </span>
		</>
	)
}
